<div *ngIf="showSummary" class="host" [class.bottom]="taskProcessContext.isPrivate()">
  <div *ngIf="isLoading; else summaryTpl" class="loading">
    <img [src]="'assets/img/ai-loading.gif'" />
    <span translate="m/task-process/summary/loading"></span>
  </div>

  <ng-template #summaryTpl>
    <div class="title">
      ✨
      <span translate="m/task-process/summary/title"></span>
      ✨
    </div>
    <div>
      {{ summary }}
    </div>
  </ng-template>
</div>
